export { default } from './GiftItemBannerContent';
